import axios from 'utils/axios';
import { put, call } from 'redux-saga/effects';
import * as Authentication from 'actions/Authentication';
import i18n from 'i18n/i18n.js';

import {toastr} from 'react-redux-toastr'

export function* onCreateRequest({ payload, cb }) {

  try {
    const data = {
      provider: payload.provider,
      inputToken: payload.inputToken,
      // firstName: payload.firstName,
      // lastName: payload.lastName,
      email: payload.email
    };

    const res = yield axios.post(`/api/auth/webSignin`, data);

    console.log('res.data', res.data)

    yield put(Authentication.onCreateSuccess(res.data));

    cb && cb(null, res.data);
  } catch (e) {
    console.log('onCreateRequest error')
    cb && cb(e);
    yield put(Authentication.onCreateFailure({ error: e }));
    if(e.response.data.detailMessage !== "NOT_HIT_CLUB_USER") {
      toastr.error(i18n.t('toastr.onCreateAuthenticationRequest.title'), i18n.t('toastr.onCreateAuthenticationRequest.body'), { timeOut: 15000 })
    }
    // payload.navigate('/loggain')
  }
}
